import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { UserRoutes } from "./UserRoutes";
import { PageRoutes } from "./PageRoutes";
import { checkToken } from "../apis";
import { useDispatch } from "react-redux";
import { startLoggedOut } from "../store/auth/authThunks";
// import { ModalKeepSessionAlive } from "../components/Modal/ModalKeepSessionAlive";
import { setFromUrl } from "../store/jaguar/jaguarSlice";
import { Loading } from "../components/Loading/String/Loading";

export const AppRouter = () => {
  const { isLoggedIn, tenant, status } = useSelector((state) => state.auth);
  const session = JSON.parse(localStorage.getItem("Session")) || null;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const idToken = session?.IdToken;
    const accessToken = session?.AccessToken;
    if (idToken && accessToken) {
      checkToken(idToken, accessToken)
        .then(() => {
          // console.log("Valid credentials")
        })
        .catch(() => {
          dispatch(startLoggedOut());
          navigate("/");
        });
    } else {
      dispatch(startLoggedOut());
      navigate("/");
    }
  }, []);

  // Verificar si se accede a la pagina desde una url en especifico
  useEffect(() => {
    const { pathname } = location;
    if (pathname !== "/") {
      dispatch(setFromUrl(pathname));
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn && tenant && location.pathname === "/login") {
      navigate("/dashboard", { replace: true });
    }
  }, [isLoggedIn, tenant]);

  if (status === "checking") {
    return <Loading />;
  }

  return (
    <>
      {/* <ModalKeepSessionAlive /> */}
      <Routes>
        {isLoggedIn && tenant ? (
          <Route path="/*" element={<UserRoutes />} />
        ) : (
          <Route path="/*" element={<PageRoutes />} />
        )}
      </Routes>
    </>
  );
};
